<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <form [formGroup]="apiConfigurationActionForm" class="form">
                <div class="form-container">
                    <div class="form-item">
                        <mat-form-field>
                            <mat-label>Nom</mat-label>
                            <input matInput type="text" formControlName="name" autocomplete="off" tabindex="1" />
                        </mat-form-field>
                    </div>
                    <div class="form-item">
                        <mat-form-field>
                            <mat-label>Description</mat-label>
                            <textarea
                                matInput
                                cdkTextareaAutosize
                                cdkAutosizeMinRows="3"
                                cdkAutosizeMaxRows="5"
                                formControlName="description"
                                autocomplete="off"
                                tabindex="2"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="form-item">
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <mat-select formControlName="actionType" tabindex="3" (selectionChange)="onTypeChanged($event)">
                                @for (actionType of actionsType; track actionType) {
                                    <mat-option [value]="actionType.value">
                                        {{ actionType.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </form>
            <ng-template #dynamicContainer></ng-template>
            <app-multi-level-context-menu
                [isRootNode]="true"
                [nodeData]="contextMenuItems"
                (onContextMenuItemClick)="handleMenuItemClick($event)"
                (onClosed)="CloseContextMenu()"></app-multi-level-context-menu>
        </div>
    </mat-card-content>
    <mat-card-actions>
        @if (data.readonly === true) {
            <button mat-raised-button class="accent-button" (click)="onCancel()">Ok</button>
        } @else {
            <button mat-stroked-button class="accent-button" (click)="onCancel()">Annuler</button>
            <button mat-raised-button class="accent-button" (click)="onConfirm()">Valider</button>
        }
    </mat-card-actions>
</mat-card>
